import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import { Button } from '@src/components/ui/button/button';
import { setURLState } from '@src/utils/setURLState';

export const CriminalRecordCheckSuccessModal = () => {
    const [openSuccess, setOpenSuccess] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const urlParams = new URLSearchParams(window.location.search);
            setOpenSuccess(!!urlParams.get('crc'));
        }
    }, []);

    const handleClose = () => {
        setURLState({ crc: null }, { replace: true });
        setOpenSuccess(false);
    };

    return (
        <Dialog open={openSuccess} onClose={handleClose}>
            <DialogContent>
                <DialogContentText className='tw-text-[20px] tw-text-bcaa-grey-900 tw-font-[500]'>
                    Payment for your criminal record check has been received.
                </DialogContentText>
                <div className='tw-text-[16px] tw-text-bcaa-grey-900 tw-my-[8px] tw-space-y-[16px]'>
                    <p>
                        Please check your email for a message from our partner, Certn, to proceed with the next steps.
                        If you do not receive an email, please contact BCAA Task Marketplace Customer Service team at{' '}
                        <a href='mailto:support@marketplace.bcaa.com' target='_blank' rel='noopener noreferrer'>
                            support@marketplace.bcaa.com.
                        </a>
                    </p>
                    <p>
                        Criminal record checks may take up to 24 hours to process. You will receive a follow-up email
                        from Certn once it's complete.
                    </p>
                </div>
            </DialogContent>
            <DialogActions>
                <Button className='tw-p-[8px] tw-text-[14px]' autoFocus variant='contained' onClick={handleClose}>
                    OK
                </Button>
            </DialogActions>
        </Dialog>
    );
};
